import { defineStore } from 'pinia'
import { httpRequest } from '@/services/api'
import { showAlert } from '@/composables/useAlert'

export const usePopularCarsStore = defineStore('popularCars', {
  state: () => ({
    allCars: [],
    isLoading: false
  }),

  getters: {
    // يرجع الأنواع الفريدة من type
    carTypes: (state) => {
      const types = state.allCars.map(car => car.type).filter(Boolean)
      return [...new Set(types)]
    },

    // فلترة العربيات حسب النوع
    carsByType: (state) => {
      return (type) => state.allCars.filter(car => car.type === type)
    }
  },

  actions: {
   async fetchPopularCars() {
  this.isLoading = true
  try {
    const res = await httpRequest('/cars', {
      method: 'GET',
      params: {
        pageSize: -1,
        // rent_or_sale: 'sale',
        // price_from: 100,
        // price_to: 10000
      }
    })
    this.allCars = res.data || []
  } catch (error) {
    showAlert(error.response?.data?.message || 'حدث خطأ أثناء جلب البيانات', 'error')
  } finally {
    this.isLoading = false
  }
}

  }
})
